/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RainGraph
 */
export interface RainGraph {
  /**
   *
   */
  url: string;
}

/**
 * Check if a given object implements the RainGraph interface.
 */
export function instanceOfRainGraph(value: object): value is RainGraph {
  if (!("url" in value) || value["url"] === undefined) return false;
  return true;
}

export function RainGraphFromJSON(json: any): RainGraph {
  return RainGraphFromJSONTyped(json, false);
}

export function RainGraphFromJSONTyped(json: any, ignoreDiscriminator: boolean): RainGraph {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"],
  };
}

export function RainGraphToJSON(json: any): RainGraph {
  return RainGraphToJSONTyped(json, false);
}

export function RainGraphToJSONTyped(
  value?: RainGraph | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    url: value["url"],
  };
}
